import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const AdminReportsScreen = () => {
  const [exchangeRate, setExchangeRate] = useState('');
  const [transactions, setTransactions] = useState([
    { email: 'sophia.carter@email.com', type: 'Credit', amount: 150.00, usdtValue: 150.00, status: 'Successful' },
    { email: 'liam.davis@email.com', type: 'Debit', amount: 75.50, usdtValue: 75.50, status: 'Failed' },
    { email: 'olivia.brown@email.com', type: 'Credit', amount: 200.00, usdtValue: 200.00, status: 'Successful' },
    { email: 'jackson.miller@email.com', type: 'Debit', amount: 50.00, usdtValue: 50.00, status: 'Failed' },
    { email: 'emma.wilson@email.com', type: 'Credit', amount: 120.75, usdtValue: 120.75, status: 'Successful' },
    { email: 'aiden.moore@email.com', type: 'Debit', amount: 90.00, usdtValue: 90.00, status: 'Failed' },
    { email: 'ava.taylor@email.com', type: 'Credit', amount: 300.00, usdtValue: 300.00, status: 'Successful' },
    { email: 'lucas.anderson@email.com', type: 'Debit', amount: 80.20, usdtValue: 80.20, status: 'Failed' },
    { email: 'isabella.thomas@email.com', type: 'Credit', amount: 180.00, usdtValue: 180.00, status: 'Successful' },
    { email: 'noah.jackson@email.com', type: 'Debit', amount: 45.99, usdtValue: 45.99, status: 'Failed' }
  ]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const totalTransactions = transactions.length;
  const totalAmountUSD = transactions.reduce((sum, t) => sum + t.amount, 0);
  const totalAmountUSDT = transactions.reduce((sum, t) => sum + t.usdtValue, 0);

  const handleCalculateUSDT = async (e) => {
    if (e) e.preventDefault();
    if (!exchangeRate) {
      toast.error('Please enter an exchange rate');
      return;
    }

    setIsLoading(true);
    try {
      // Mock calculation
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      const rate = parseFloat(exchangeRate);
      const updatedTransactions = transactions.map(t => ({
        ...t,
        usdtValue: (t.amount * rate).toFixed(2)
      }));
      
      setTransactions(updatedTransactions);
      toast.success('USDT values calculated successfully!');
    } catch (error) {
      toast.error('Error calculating USDT values');
    } finally {
      setIsLoading(false);
    }
  };

  const handleConfirmUpload = async () => {
    setIsLoading(true);
    try {
      // Mock API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      toast.success('Transactions uploaded successfully!');
    } catch (error) {
      toast.error('Error uploading transactions');
    } finally {
      setIsLoading(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('is_admin');
    navigate('/admin');
  };

  return (
    <div className="container">
      <div className="admin-header-fullwidth">
        <div className="admin-header-content">
          <div className="admin-header-left">
            <img src="/logo.svg" alt="Project 31 Logo" className="admin-logo" />
           
          </div>
          
          <div className="admin-nav">
            <a href="/admin/dashboard">Dashboard</a>
            <a href="/admin/transactions">Transactions</a>
            <a href="/admin/manage-accounts">Accounts</a>
            <a href="/admin/bitcoins">Bitcoins</a>
          </div>
        </div>
      </div>

      <div className="dashboard-content admin-dashboard-content">
        <div className="transaction-preview-section">
          <h2>Transaction Upload Preview</h2>
          <p className="preview-description">
            Review the uploaded transaction data before finalizing the import. Ensure all entries are accurate and valid.
          </p>
          
          <form className="preview-controls" onSubmit={handleCalculateUSDT}>
            <div className="exchange-rate-input">
              <label htmlFor="exchangeRate">Exchange Rate (USD to USDT)</label>
              <input
                type="number"
                id="exchangeRate"
                value={exchangeRate}
                onChange={(e) => setExchangeRate(e.target.value)}
                placeholder="Enter exchange rate"
                step="0.0001"
              />
            </div>

            <div className="summary-stats">
              <div className="stat-item">
                <span className="stat-label">Total Transactions</span>
                <span className="stat-value">{totalTransactions}</span>
              </div>
              <div className="stat-item">
                <span className="stat-label">Total Amount (USD)</span>
                <span className="stat-value">${totalAmountUSD.toFixed(2)}</span>
              </div>
              <div className="stat-item">
                <span className="stat-label">Total Amount (USDT)</span>
                <span className="stat-value">${totalAmountUSDT.toFixed(2)}</span>
              </div>
              <button
                type="submit"
                className="calculate-button"
                disabled={isLoading || !exchangeRate}
              >
                Calculate USDT
              </button>
            </div>
          </form>

          <div className="transactions-table-container">
            <table className="transactions-table">
              <thead>
                <tr>
                  <th>Email</th>
                  <th>Type</th>
                  <th>Amount</th>
                  <th>USDT Value</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {transactions.map((transaction, index) => (
                  <tr key={index}>
                    <td>{transaction.email}</td>
                    <td>{transaction.type}</td>
                    <td>${transaction.amount.toFixed(2)}</td>
                    <td>${parseFloat(transaction.usdtValue).toFixed(2)}</td>
                    <td>
                      <span className={`status-badge ${transaction.status.toLowerCase()}`}>
                        {transaction.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="preview-actions">
            <button 
              className="confirm-upload-button"
              onClick={handleConfirmUpload}
              disabled={isLoading}
            >
              {isLoading ? 'Processing...' : 'Confirm Upload'}
            </button>
          </div>
        </div>
      </div>

      <div className="admin-footer">
        <button onClick={handleLogout} className="admin-logout-button">
          Logout
        </button>
      </div>
    </div>
  );
};

export default AdminReportsScreen;

